import * as types from "./actions";

const defaultState = {
    list: [],
    tableHeader: [
        {
            label: "履歴No",
            button: false,
            id: true,
            rightAlign: true
        },
        {
            label: "送信日時",
            button: false
        },
        {
            label: "連絡先",
            button: false,
            contentClass: "truncate",
            headerClass: "nameRow"
        },
        {
            label: "タイトル",
            button: false,
            contentClass: "truncate",
            headerClass: "titleRow"
        },
        {
            label: "内容",
            button: true
        }
    ],
    tableColumns: [
        "contactNumber",
        "sendDateTime",
        "proposalName",
        "title"
    ],
    deliveryForm: [
        {
            type: "sendDateTime",
            label: "送信日時",
            placeholder: "",
            name: "sendDateTime",
            disabled: true
        },
        {
            type: "text",
            label: "タイトル",
            placeholder: "",
            minLength: 1,
            maxLength: 128,
            name: "title",
            required: true,
            disabled: false
        },
        {
            type: "high-textarea",
            className: "web-textarea",
            componentClass: "textarea",
            label: "内容",
            placeholder: "",
            minLength: 1,
            maxLength: 1024,
            name: "message",
            required: true,
            bgGreen: true,
            disabled: false
        },
        {
            type: "distributor",
            label: "連絡先",
            disabled: false
        }
    ]
}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.LIST:
            return { ...state, list: action.payload };
        default: // need this for default case
            return state
    }
};
